module.exports = __webpack_public_path__ + "static/media/tabler_link.b07aa717.svg";